import { EventQuery } from "lib/build/events";

export const queries: { [key: string]: EventQuery } = {
	status: {
		interpretation: { vocab: "htx", code: "patient_status" }
	},
	address: {
		interpretation: { vocab: "snomed", code: "184097001" }
	},
	weight: {
		interpretation: { vocab: "htx", code: "weight" }
	},
	ab0: {
		interpretation: { vocab: "htx", code: "ab0" }
	},
	rh: {
		interpretation: { vocab: "htx", code: "rh" }
	},
	pvr: {
		interpretation: { vocab: "htx", code: "pvr" }
	},
	waitingListStartDate: {
		interpretation: { vocab: "htx", code: "waiting_list_start_date" }
	},
	urgency: {
		interpretation: { vocab: "htx", code: "urgency" }
	},
	combinedTransplant: {
		interpretation: { vocab: "htx", code: "combined_transplant" }
	}
};
